import { render, staticRenderFns } from "./SelectionSummary.vue?vue&type=template&id=0eb32057&scoped=true&"
import script from "./SelectionSummary.vue?vue&type=script&lang=js&"
export * from "./SelectionSummary.vue?vue&type=script&lang=js&"
import style0 from "./SelectionSummary.vue?vue&type=style&index=0&id=0eb32057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb32057",
  null
  
)

export default component.exports